import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./LibraryUIHelpers";

const LibraryUIContext = createContext();

export function useLibraryUIContext() {
  return useContext(LibraryUIContext);
}

export const LibraryUIConsumer = LibraryUIContext.Consumer;

export function LibraryUIProvider({ libraryUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initLibrary = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initLibrary,
    newLibraryButtonClick: libraryUIEvents.newLibraryButtonClick,
    openEditLibraryPage: libraryUIEvents.openEditLibraryPage,
    openLibraryFilePage: libraryUIEvents.openLibraryFilePage
  };

  return (
    <LibraryUIContext.Provider value={value}>
      {children}
    </LibraryUIContext.Provider>
  );
}
